/**
 * Used for remove HTML markup from string.
 * It wont remove HTML entities
 * @param {String} htmlString - String containing html markup
 * @return {String} stripped string
 */

function stripHTML(htmlString) {
    return htmlString.replace(/<[^>]+>/g, '');
}

export default stripHTML;
